import { Box } from '@mui/material';
import DOMPurify from 'dompurify';
import React from 'react';
export const UserChatMessage = ({ message }) => (React.createElement(Box, { className: "user-input", "data-cy": "userInput" },
    React.createElement("div", { dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(`<p>${message}</p>`),
        } })));
